import React from "react";
import "./warszawaZaufaniePL";
const ZaufanieWarszawa: React.FC = () => {
  return (
    <div>
      <div id="sff_127__widget-container"></div>
    </div>
  );
};

export default ZaufanieWarszawa;
